import { useVeriModel, UseVeriModelOptions } from "../../useVeriModel";
import { VerificationModel } from "../../../models";
import apiVerificationModel from "./apiVerificationModel";

export default function useVerificationModel(
  opts?: UseVeriModelOptions<VerificationModel>,
) {
  return useVeriModel(apiVerificationModel, opts);
}
